import type { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import type { JSX } from 'react'
import { HoverTask } from '#src/components/HoverTask.tsx'
import { useCreatedOn } from '#src/hooks/useCreatedOn.ts'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'

export function TaskTimelineItem({
  task,
}: {
  task: StandardTask
}): JSX.Element {
  const { data: createdOn } = useCreatedOn(task.reference)
  return (
    <TimelineTextEntry
      actor={task.lastUpdatedBy}
      time={task.lastModified ?? task.lastUpdated}
      action={
        <>
          {createdOn === task.lastUpdated ? 'created' : 'updated'} task{' '}
          <HoverTask task={task} />
        </>
      }
      reference={task.reference}
      originTask={task.queuedEditsOriginTask}
    />
  )
}
